/**
 * Function to generate a 6 digit code
 * @returns string - 6 digit code
 */
export const generateSixDigitCode = (): string => {
  const min = 100000;
  const max = 999999;
  const code = Math.floor(Math.random() * (max - min + 1)) + min;
  return code.toString();
};
